function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  className: "success",
  clipRule: "evenodd",
  d: "M22 39.5C26.6413 39.5 31.0925 37.6563 34.3744 34.3744C37.6563 31.0925 39.5 26.6413 39.5 22C39.5 17.3587 37.6563 12.9075 34.3744 9.62563C31.0925 6.34374 26.6413 4.5 22 4.5C17.3587 4.5 12.9075 6.34374 9.62563 9.62563C6.34374 12.9075 4.5 17.3587 4.5 22C4.5 26.6413 6.34374 31.0925 9.62563 34.3744C12.9075 37.6563 17.3587 39.5 22 39.5ZM22 42C27.3043 42 32.3914 39.8929 36.1421 36.1421C39.8929 32.3914 42 27.3043 42 22C42 16.6957 39.8929 11.6086 36.1421 7.85786C32.3914 4.10714 27.3043 2 22 2C16.6957 2 11.6086 4.10714 7.85786 7.85786C4.10714 11.6086 2 16.6957 2 22C2 27.3043 4.10714 32.3914 7.85786 36.1421C11.6086 39.8929 16.6957 42 22 42Z",
  fill: "#3C50E0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.8005 15.3661C33.2887 15.8543 33.2887 16.6457 32.8005 17.1339L19.9672 29.9672C19.4791 30.4554 18.6876 30.4554 18.1994 29.9672L12.3661 24.1339C11.878 23.6457 11.878 22.8543 12.3661 22.3661C12.8543 21.878 13.6457 21.878 14.1339 22.3661L19.0833 27.3156L31.0328 15.3661C31.5209 14.878 32.3124 14.878 32.8005 15.3661Z",
  fill: "#24C952"
});

var SvgCheckCircle = function SvgCheckCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-circle.333eaa54.svg";
export { ForwardRef as ReactComponent };